import { useState } from 'react'
import { onChange } from '../../../../../../../utils/types'

const useCreatEdit = () => {
  const [dataCrud, setDataCrud] = useState<Record<string, unknown>>({})

  const onChangeCrud: onChange = ({ target }) => {
    const { name, value } = target
    setDataCrud((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handledataCrud = (data?: Record<string, unknown>) => {
    setDataCrud(data ?? {})
  }

  return { dataCrud, handledataCrud, onChangeCrud }
}

export { useCreatEdit }